import { ChatWorkspace } from "@/components/chat/chat-workspace";
import { Chat as ChatType, ChatWithMessagesType } from "@/types/chat";
import { WhatsappStatus } from "@/types/whatsapp";
import { Head } from "@inertiajs/react";

export default function Show({
  chats,
  status,
  selectedChat,
  canSendMessage,
  canMarkSale,
  saleMarkedInLast24h,
  archivedMode,
  isArchived,
}: {
  chats: ChatType[];
  status: WhatsappStatus;
  selectedChat: ChatWithMessagesType;
  canSendMessage?: boolean;
  canMarkSale?: boolean;
  saleMarkedInLast24h?: boolean;
  archivedMode?: boolean;
  isArchived?: boolean;
}) {
  return (
    <>
      <Head title={selectedChat.name} />
      <ChatWorkspace
        chats={chats}
        status={status}
        selectedChat={selectedChat}
        canSendMessage={canSendMessage}
        canMarkSale={canMarkSale}
        saleMarkedInLast24h={saleMarkedInLast24h}
        archivedMode={archivedMode}
        isArchived={isArchived}
      />
    </>
  );
}
